export const translation = {
    'success': 'Skopírované',
    'error': 'Vyskytla sa chyba pri kopírovaní',
}